export default __webpack_public_path__ + "assets/ic-clover-logo-white.svg";